export const setTariffFormButtonData = () => {
    const tariffForm = document.querySelector('#tariff-modal form');
    const tariffButtons = document.querySelectorAll('.tariffButton');

    tariffButtons.forEach(tariffButton => {
        tariffButton.addEventListener('click', () => {
            if (tariffForm) {
                const iconElement = tariffForm.querySelector('.popap-accordion_title .icon img');
                if (iconElement) {
                    iconElement.src = tariffButton.dataset.icon;
                    iconElement.alt = tariffButton.dataset.name;
                }

                const nameElement = tariffForm.querySelector('.popap-accordion_title .name span');
                if (nameElement) {
                    nameElement.textContent = tariffButton.dataset.name;
                }

                const priceElement = tariffForm.querySelector('.field_price');
                if (priceElement) {
                    priceElement.textContent = tariffButton.dataset.price;
                }

                const connectionFeeElement = tariffForm.querySelector('.field_connection_fee');
                if (connectionFeeElement) {
                    connectionFeeElement.textContent = tariffButton.dataset.connectionfee ? tariffButton.dataset.connectionfee : '0';
                }

                tariffForm.querySelector("input[name=type]").value = tariffButton.dataset.type;
                tariffForm.querySelector("input[name=provider_name]").value = tariffButton.dataset.provider_name;
            }

            //open popup
            const tariffModal = document.getElementById('tariff-modal');
            const formSuccess = tariffModal.querySelector('.form-data__result');
            const form = tariffModal.querySelector('.form-data__input');
            const message = form.querySelector('.message')
            if (!tariffModal.classList.contains('active')) {
                message.innerHTML = '';
                tariffModal.classList.add('active');
                tariffButton.classList.add('active');
                form.classList.remove('hide');
                formSuccess.classList.add('hide');
            }

        })
    })
}

document.addEventListener('DOMContentLoaded', setTariffFormButtonData)
